/**
 * Shared formatting utilities for ReportTab components
 */

// Format date string to locale date
export const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString();
};

// Format numeric value with 2 decimal places
export const formatValue = (value) => {
  if (value === null || value === undefined) return 'N/A';
  if (typeof value === 'number') {
    return value.toFixed(2);
  }
  // Handle string values by converting to number first
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return numValue.toFixed(2);
};

// Format numbers for consumption display - no decimals, with thousand separators
export const formatConsumptionValue = (value) => {
  if (value === null || value === undefined || value === 'N/A') return 'N/A';
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return Math.round(numValue).toLocaleString();
};

// Format battery voltage with 3 decimal places
export const formatBatteryVoltage = (value) => {
  if (value === null || value === undefined) return 'N/A';
  const numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return numValue.toFixed(3);
};

// Format RSSI with 1 decimal place
export const formatRSSI = (value) => {
  if (value === null || value === undefined) return 'N/A';
  const numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return numValue.toFixed(1);
};

// Format temperature with 1 decimal place
export const formatTemperature = (value) => {
  if (value === null || value === undefined) return 'N/A';
  const numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return numValue.toFixed(1);
};

// Format meter value with 2 decimal places
export const formatMeterValue = (value) => {
  if (value === null || value === undefined) return 'N/A';
  const numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  return numValue.toFixed(2);
};

// Format date and time for display
export const formatDateTime = (dateTime) => {
  if (!dateTime) return 'N/A';
  return new Date(dateTime).toLocaleString();
};

// Format configuration values (handles booleans and numbers)
export const formatConfigValue = (configData) => {
  if (!configData || configData.value === null || configData.value === undefined) {
    return 'N/A';
  }
  
  if (typeof configData.value === 'boolean') {
    return configData.value ? 'Yes' : 'No';
  }
  
  return configData.value.toString();
};

// Validate coordinate values for mapping
export const isValidCoordinate = (lat, lon) => {
  if (lat == null || lon == null) return false;
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return false;
  return true;
};